import { BadgeConfigurationRequest, BadgeConfigurationRequestFromBadgeConfiguration } from "./BadgeConfigurationRequest";
import { Client } from "../model/Client";

export interface ClientRequest {
    timezone: string;
    name: string;
    workRegionId: number;
    notifyOnNewRole: string;

    clientBadgesEnabled: boolean;
    badgeConfiguration?: BadgeConfigurationRequest;
}

export const ClientRequestFromClient = (client: Client): ClientRequest => {
    return {
        timezone: client.timezone,
        name: client.name,
        workRegionId: client.region.id,
        notifyOnNewRole: client.notifyOnNewRole,
        clientBadgesEnabled: client.clientBadgesEnabled,
        badgeConfiguration: BadgeConfigurationRequestFromBadgeConfiguration(client.badgeConfiguration)
    };
};
